import Image from 'next/image';
import playBasicNext from '../../svgs/play_basic_icon.svg';
import playBasicNextN500 from '../../svgs/play_basic_icon_n500.svg';
import { NextImageProps } from '../NextImageProps';

type ExtendedNextImageProps = NextImageProps & {
  color?: 'black' | 'neutral-500';
};
export function PlayBasicNext({ className, width, height, alt, color }: ExtendedNextImageProps) {
  let imageSrc = playBasicNext;
  if (color) {
    switch (color) {
      case 'black':
        imageSrc = playBasicNext;
        break;
      case 'neutral-500':
        imageSrc = playBasicNextN500;
        break;
      default:
        break;
    }
  }
  return (
    <Image
      className={className}
      src={imageSrc}
      width={width}
      height={height}
      alt={alt ?? 'Afspil'}
    />
  );
}
